import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_BASE_URL } from "../config";

function CBCForm() {
  const initialForm = {
    name: "",
    ageSex: "",
    doctor: "",
    date: "",
    heamoglobin: "",
    rbc: "",
    pcv: "",
    mcv: "",
    mch: "",
    mchc: "",
    rdw: "",
    wbc: "",
    neutrophils: "",
    lymphocytes: "",
    monocytes: "",
    eosinophils: "",
    basophils: "",
    platelet: "",
    mpv: "",
  };

  const [form, setForm] = useState(initialForm);
  const [reports, setReports] = useState([]);
  const [editId, setEditId] = useState(null);
  const [viewData, setViewData] = useState(null);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = () => {
    axios
      .get(`${API_BASE_URL}/api/cbc-reports`)
      .then((res) => setReports(res.data))
      .catch((err) => console.error("Error fetching reports:", err));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (editId) {
      axios
        .put(`${API_BASE_URL}/api/cbc-reports/${editId}`, form)
        .then(() => {
          alert("CBC Report Updated!");
          setForm(initialForm);
          setEditId(null);
          fetchReports();
        })
        .catch(() => alert("Error updating CBC Report!"));
    } else {
      axios
        .post(`${API_BASE_URL}/api/cbc-reports`, form)
        .then(() => {
          alert("CBC Report Saved!");
          setForm(initialForm);
          fetchReports();
        })
        .catch(() => alert("Error saving CBC Report!"));
    }
  };

  const handleEdit = (report) => {
    setForm(report);
    setEditId(report.id);
    setViewData(null);
    window.scrollTo(0, 0);
  };

  const handleView = (report) => {
    setViewData(report);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this report?")) {
      axios
        .delete(`${API_BASE_URL}/api/cbc-reports/${id}`)
        .then(() => {
          alert("CBC Report Deleted!");
          fetchReports();
        })
        .catch(() => alert("Error deleting CBC Report!"));
    }
  };

  return (
    <>
      <div className="container my-3">
        <h3>CBC Report Form {editId ? "(Edit)" : "(New)"}</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5>HEAMOGRAM VALUES</h5>
        <div className="row">
          {[
            ["Heamoglobin", "heamoglobin"],
            ["RBC Count", "rbc"],
            ["PCV", "pcv"],
            ["MCV", "mcv"],
            ["MCH", "mch"],
            ["MCHC", "mchc"],
            ["RDW", "rdw"],
            ["WBC", "wbc"],
            ["Neutrophils", "neutrophils"],
            ["Lymphocytes", "lymphocytes"],
            ["Monocytes", "monocytes"],
            ["Eosinophils", "eosinophils"],
            ["Basophils", "basophils"],
            ["Platelet Count", "platelet"],
            ["MPV", "mpv"],
          ].map(([label, name]) => (
            <div className="col-md-4 mb-2" key={name}>
              <label>{label}:</label>
              <input
                type="text"
                className="form-control"
                name={name}
                value={form[name]}
                onChange={handleChange}
              />
            </div>
          ))}
        </div>

        <button className="btn btn-success mt-3" onClick={handleSubmit}>
          💾 {editId ? "Update Report" : "Save Report"}
        </button>

        <hr />

        <h4 className="mt-4">CBC Reports List</h4>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Pt. Name</th>
              <th>Age/Sex</th>
              <th>Date</th>
              <th>Doctor</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report) => (
              <tr key={report.id}>
                <td>{report.name}</td>
                <td>{report.ageSex}</td>
                <td>{report.date}</td>
                <td>{report.doctor}</td>
                <td>
                  <button
                    className="btn btn-info btn-sm me-2"
                    onClick={() => handleView(report)}
                  >
                    👁️
                  </button>
                  <button
                    className="btn btn-warning btn-sm me-2"
                    onClick={() => handleEdit(report)}
                  >
                    ✏️
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(report.id)}
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Print Area */}
        {viewData && (
          <>
            <hr />
            <div
              className="print-area"
              style={{
                fontFamily: "sans-serif",
                fontSize: "14px",
                color: "#000",
                padding: "10mm",
              }}
            >
              {/* Lab Header */}
              <div
                style={{
                  fontSize: "28px",
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: "10px",
                }}
              >
                माँ बाघेश्वरी पैथालॉजी लैबोरेटरी
              </div>

              {/* Patient Info */}
              <table
                style={{ width: "100%", marginBottom: "15px", border: "none" }}
              >
                <tbody>
                  <tr>
                    <td style={{ width: "50%" }}>
                      <strong>Pt. Name:</strong> {viewData.name}
                    </td>
                    <td className="text-end" style={{ width: "50%" }}>
                      <strong>Ref. by Dr.:</strong> {viewData.doctor}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Age/Sex:</strong> {viewData.ageSex}
                    </td>
                    <td className="text-end">
                      <strong>Date:</strong> {viewData.date}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* HEAMOGRAM Title */}
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                HEAMOGRAM
              </div>

              {/* HEAMOGRAM Table */}
              <table
                className="table table-bordered"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th>INVESTIGATION</th>
                    <th>RESULT</th>
                    <th>UNIT</th>
                    <th>BIOLOGICAL REFERENCE INTERVAL</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "Haemoglobin",
                      viewData.heamoglobin,
                      "Gm%",
                      "Male(12.5-18), F(11.5-16)",
                    ],
                    [
                      "RBC Count",
                      viewData.rbc,
                      "Mill/Cumm",
                      "M(4.5-6.5), F(3.5-4.7)",
                    ],
                    ["PCV", viewData.pcv, "%", "M(40-52), F(35-40)"],
                    ["MCV", viewData.mcv, "FL", "82-92"],
                    ["MCH", viewData.mch, "PG", "27-32"],
                    ["MCHC", viewData.mchc, "G/dL", "32-36"],
                    ["RDW", viewData.rdw, "%", "11.5-14.5"],
                    ["Total WBC", viewData.wbc, "/Cumm", "4000-11000"],
                  ].map(([label, value, unit, normal]) => (
                    <tr key={label}>
                      <td>{label}</td>
                      <td>{value}</td>
                      <td>{unit}</td>
                      <td>{normal}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* DLC Title */}
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                DIFFERENTIAL LEUCOCYTE COUNT (DLC)
              </div>

              {/* DLC Table */}
              <table
                className="table table-bordered"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th>Cell Type</th>
                    <th>RESULT</th>
                    <th>%</th>
                    <th>Reference</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Neutrophils", viewData.neutrophils, "%", "40-75"],
                    ["Lymphocytes", viewData.lymphocytes, "%", "20-45"],
                    ["Monocytes", viewData.monocytes, "%", "2-8"],
                    ["Eosinophils", viewData.eosinophils, "%", "1-4"],
                    ["Basophils", viewData.basophils, "%", "0-1"],
                    [
                      "Platelet Count",
                      viewData.platelet,
                      "thou/mm3",
                      "1.5-4.5 Lacks/cumm",
                    ],
                    ["MPV", viewData.mpv, "fl", "7.4-10.4"],
                  ].map(([label, value, unit, normal]) => (
                    <tr key={label}>
                      <td>{label}</td>
                      <td>{value}</td>
                      <td>{unit}</td>
                      <td>{normal}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Footer */}
              <p className=" mt-2">
                <strong className="text-center">*****END OF REPORT*****</strong>
                Technologist
              </p>
            </div>
            <button
              className="no-print btn btn-primary my-3"
              onClick={() => window.print()}
            >
              🖨️ Print Report
            </button>
          </>
        )}
      </div>
    </>
  );
}

export default CBCForm;
